// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__5UCXF","footer":"ModalError_footer__2-l44"};